import { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import useFeatureFlag from '@modules/FeatureFlagModule/hooks/useFeatureFlag/useFeatureFlag';
import { useTransferQueuesState } from './useTransferQueuesState';
import QueuesTable from '../QueuesTable/QueuesTable';
import { OutboundCallDetails } from '../../types';

interface TransferModalQueuesProps {
  setCallDetails: (details: OutboundCallDetails) => void;
}

const TransferModalQueues: React.FC<TransferModalQueuesProps> = ({
  setCallDetails,
}) => {
  const flagEnabled = useFeatureFlag(
    FeatureFlagKeys.featureShowQueueWarningInTransfer,
    { defaultValue: false },
  );
  const { queues, loading } = useTransferQueuesState({
    useStrictAvailability: flagEnabled,
    computeFallbackWarning: flagEnabled,
  });
  return (
    <QueuesTable
      queues={queues}
      loading={loading}
      setCallDetails={setCallDetails}
      initialSort={[{ field: 'name', dir: 'asc' }]}
      useStrictAvailability={flagEnabled}
    />
  );
};

export default TransferModalQueues;
